import type * as Types from 'app/types/graphql';

import { VariantUrlSelectFragmentDoc } from '../fragments/variantUrl.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantUrlUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateVariantUrlInput;
}>;

export type VariantUrlUpdateMutationResponse = {
  variantURLUpdate?: Types.Maybe<
    Pick<Types.VariantUrl, 'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'>
  >;
};

export const VariantUrlUpdateDocument = `
    mutation VariantURLUpdate($id: ID!, $input: UpdateVariantURLInput!) {
  variantURLUpdate(id: $id, input: $input) {
    ...VariantURLSelect
  }
}
    ${VariantUrlSelectFragmentDoc}`;

export const useVariantUrlUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantUrlUpdateMutationResponse,
    TError,
    VariantUrlUpdateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantUrlUpdateMutationResponse,
    TError,
    VariantUrlUpdateMutationVariables,
    TContext
  >(
    ['VariantURLUpdate'],
    (variables?: VariantUrlUpdateMutationVariables) =>
      appFetcher<VariantUrlUpdateMutationResponse, VariantUrlUpdateMutationVariables>(
        VariantUrlUpdateDocument,
        variables,
      )(),
    options,
  );
};

useVariantUrlUpdateMutation.getKey = () => ['VariantURLUpdate'];
